<script setup lang="ts">
import StatsItem from "@/stats/StatsItem.vue";
import { allStatsItems } from "@/stats/statsItems";
import type { Stats } from "@/stats/types";
import { computed } from "vue";

const { stats, displayCards = false } = defineProps<{
  stats: Partial<Stats>;
  displayCards?: boolean;
}>();
const statsList = computed(
  () => Object.entries(stats) as [keyof Stats, number][],
);
</script>

<template>
  <div class="stats">
    <ul v-if="!displayCards" role="list" class="stats-list">
      <li v-for="[key, value] in statsList" :key="key">
        <component :is="allStatsItems[key].icon" /> {{ value }}
        {{ allStatsItems[key].text }}
      </li>
    </ul>

    <div v-if="displayCards" class="stats-cards">
      <StatsItem v-for="[key, value] in statsList" :key="key" class="item">
        <template #header>
          <component :is="allStatsItems[key].icon" />
          {{ allStatsItems[key].text }}
        </template>
        {{ value }}
      </StatsItem>
    </div>
  </div>
</template>

<style scoped>
.stats-list {
  color: var(--color-primary);

  svg {
    margin-inline-end: var(--spacing-sm);
  }
}

.stats-cards {
  display: grid;
  gap: 1rem;

  grid-template-columns: 1fr 1fr;

  @media (min-width: 60rem) {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
